var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.08333 3.50033V1.75033C4.08333 1.59562 4.14479 1.44724 4.25419 1.33785C4.36358 1.22845 4.51196 1.16699 4.66667 1.16699H11.6667C11.8214 1.16699 11.9697 1.22845 12.0791 1.33785C12.1885 1.44724 12.25 1.59562 12.25 1.75033V9.91699C12.25 10.0717 12.1885 10.2201 12.0791 10.3295C11.9697 10.4389 11.8214 10.5003 11.6667 10.5003H9.91667V12.2503C9.91667 12.5723 9.65417 12.8337 9.32925 12.8337H2.33742C2.26049 12.8341 2.18423 12.8194 2.11302 12.7903C2.04181 12.7612 1.97705 12.7183 1.92247 12.6641C1.86788 12.6099 1.82455 12.5454 1.79495 12.4744C1.76535 12.4034 1.75008 12.3273 1.75 12.2503L1.75175 4.08366C1.75175 3.76166 2.01425 3.50033 2.33917 3.50033H4.08333ZM5.25 3.50033H9.91667V9.33366H11.0833V2.33366H5.25V3.50033Z",
    fill: "#3F7CDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyBlue);
export default __webpack_public_path__ + "static/media/copy-blue.b512c89cbed25e506d33feeba80316a0.svg";
export { ForwardRef as ReactComponent };